<template>
  <el-form :model="form" ref="form" label-position="top">
    <el-row>
      <el-col :span="12">
        <el-form-item label="回执缓存时间" prop="cachetime">
          <el-input v-model="form.cachetime"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="批处理数量" prop="readsize">
          <el-input v-model="form.readsize"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="版本" prop="as3version">
          <el-input v-model="form.as3version"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="数据最大容量" prop="maxsize">
          <el-input-number v-model="form.maxsize"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="阈值" prop="threshold">
          <el-input-number v-model="form.threshold"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="轮训时间间隔" prop="listidle">
          <el-input v-model="form.listidle"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="限定扩展名" prop="speexts">
          <el-input v-model="form.speexts"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="限制扩展名" prop="excexts">
          <el-input v-model="form.excexts"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否延迟处理MDN" prop="mdndelay">
          <el-switch
            v-model="form.mdndelay"
            active-text="开"
            inactive-text="关">
          </el-switch>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
  import rApi from "@/api/senior/seniorconf";
let datafault = {
};
export default {
  components: { rApi },
  props: {
    uuid:""
  },
  data() {
    return {
      form:{
        cachetime:3600,
        readsize:512,
        as3version:"1.2",
        maxsize:4194304,
        threshold:2000,
        listidle:"10,30",
        speexts:"",
        excexts:"",
        mdndelay:true
      }
    };
  },
  mounted() {
    if(this.uuid){
      rApi.getCsSenior(this.uuid).then(resp=>{
        var _form = JSON.parse(resp.data);
        this.form.cachetime = _form.cachetime?_form.cachetime:this.form.cachetime;
        this.form.readsize = _form.readsize?_form.readsize:this.form.readsize;
        this.form.as3version = _form.as3version?_form.as3version:this.form.as3version;
        this.form.maxsize = _form.maxsize?_form.maxsize:this.form.maxsize;
        this.form.threshold = _form.threshold?_form.threshold:this.form.threshold;
        this.form.listidle = _form.listidle?_form.listidle:this.form.listidle;
        this.form.speexts = _form.speexts?_form.speexts:this.form.speexts;
        this.form.excexts = _form.excexts?_form.excexts:this.form.excexts;
        this.form.mdndelay = _form.mdndelay||_form.mdndelay===false?_form.mdndelay:this.form.mdndelay;
      });
    }
  },
  methods: {
    save(){
      if(this.uuid){
        rApi.doSaveForCsSenior(this.uuid,JSON.stringify(this.form)).then(()=>this.$message.success("操作成功！"));
      }
      return this.form;
    }
  }
};
</script>
<style scoped>
</style>